import {Component, Input, OnInit} from '@angular/core';
import {
  CustomerRecordFieldType,
  CustomerRecordListModel,
  CustomerRecordTaskRecordData
} from "../../../../util/customer-record-utils";
import {Set} from "immutable";
import {TaskRecord, TaskRecordService} from "../../../../lib/task/task-record.service";
import {OrderType} from "../../../../lib/util/services";
import {TaskRecordStateMachine} from "../../../../lib/task/task-record-statemachine";
import {Address} from "../../../../lib/address";
import {ConfigModel} from "../../../../util/task-record-utils";
import {UserMultiselectProvider} from "../../../../lib/user/user-multiselect.provider";
import {UserGroupMultiselectProvider} from "../../../../lib/user-group/user-group-multiselect.provider";

@Component({
  selector: 'app-customer-record-list-popover',
  templateUrl: './customer-record-list-popover.component.html',
  styleUrls: ['./customer-record-list-popover.component.scss']
})
export class CustomerRecordListPopoverComponent implements OnInit {

  CustomerRecordFieldType = CustomerRecordFieldType;
  Address = Address;

  @Input()
  customerRecord: CustomerRecordListModel;

  @Input()
  config: ConfigModel = new ConfigModel();

  constructor(private taskRecordService: TaskRecordService,
              private userMultiselectProvider: UserMultiselectProvider,
              private userGroupMultiselectProvider: UserGroupMultiselectProvider,
  ) {
  }

  ngOnInit(): void {
  }

  onCustomerRecordPopoverShown() {
    this.loadTaskRecordIfNeeded();
    this.loadUsersIfNeeded();
    this.loadUserGroupsIfNeeded();
  }

  private loadTaskRecordIfNeeded() {
    if (this.customerRecord.taskRecordData) {
      return;
    }
    this.taskRecordService.globalQuery({
      baseCustomerRecord: this.customerRecord.customerRecordId,
      paging: {
        pageNumber: 1,
        numberOfItems: 1
      },
      parentDisabled: false,
      fields: Set.of('id', 'name', 'state', 'creation_time', 'task_id', 'assignee',
        'last_state_change_log_with_message'),
      orders: Set.of({field: TaskRecord.OrderField.CREATION_TIME, type: OrderType.DESC}),
      noProgressBar: true
    }).subscribe(result => {
      const data: CustomerRecordTaskRecordData = new CustomerRecordTaskRecordData();
      data.taskRecordCount = result.pagingResult.currentNumberOfItems;
      if (result.items.size > 0) {
        const tr = result.items.get(0)!;
        data.latestTaskRecordData = {
          id: tr.taskRecordId,
          taskId: tr.taskRecordId,
          name: tr.name,
          creationTime: tr.creationTime,
          state: TaskRecordStateMachine.taskRecordStates.get(tr.state),
          lastStateChangeLogWithMessage: tr.lastStateChangeLogWithMessage,
          assignee: tr.assignee
        };
      }
      this.customerRecord.taskRecordData = data;
    });
  }

  private loadUsersIfNeeded() {
    if (this.customerRecord.ownerUsers != undefined) {
      return;
    }
    if (this.customerRecord.ownerUserIds != undefined
      && this.customerRecord.ownerUserIds.length > 0) {
      this.userMultiselectProvider.getByIds(this.customerRecord.ownerUserIds)
        .subscribe(users => {
          this.customerRecord.ownerUsers = users.filter(u => !u.disabled);
        });
    } else {
      this.customerRecord.ownerUsers = [];
    }

  }

  private loadUserGroupsIfNeeded() {
    if (this.customerRecord.ownerGroups != undefined) {
      return;
    }
    if (this.customerRecord.ownerGroupIds != undefined
      && this.customerRecord.ownerGroupIds.length > 0) {
      this.userGroupMultiselectProvider.getByIds(this.customerRecord.ownerGroupIds)
        .subscribe(groups => {
          this.customerRecord.ownerGroups = groups.filter(g => !g.disabled);
        });
    } else {
      this.customerRecord.ownerGroups = [];
    }

  }

}
